(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3001],{

/***/ 26102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83157);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54076);










const StudiesFAQ = ({ faqdata  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 3,
        rows: 3,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    dotsClass: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sliderDots),
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().studyquas),
            style: {
                backgroundColor: faqdata?.sectionBgColor || "#EFEFFA"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: faqdata?.sectionTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().popularCourseslider),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().slider),
                                    ref: sliderRef,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            children: faqdata?.questions?.length > 0 && faqdata?.questions?.map((faqsdata)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    xl: 6,
                                                    lg: 6,
                                                    md: 6,
                                                    sm: 12,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        defaultActiveKey: "0",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuAccordion),
                                                            eventKey: "1",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Header */ .Z.Header, {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accoHead),
                                                                    children: faqsdata?.question
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accorBody),
                                                                    children: faqsdata?.answer
                                                                })
                                                            ]
                                                        })
                                                    })
                                                });
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (StudiesFAQ);


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 84623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65822);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78409);
/* harmony import */ var _utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3265);
/* harmony import */ var _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90017);










const NeedGuidance = ({ classname , button2Data  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const applyCtaButtonProps1 = (0,_utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__/* .getOnboardingOrFormCtaProps */ .J)(router, {
        btnLink: button2Data?.link,
        formId: button2Data?.formId,
        toOnboardingEnabled: button2Data?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,_utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__/* .persistSourceContext */ .jW)({
                    sourceUrl: window.location.href,
                    primarySource: _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__/* .PRIMARY_SOURCE_B2C_WIDGET */ .ov,
                    fifthStepVisible: button2Data?.nearestOffice ?? true,
                    coachingVisible: button2Data?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "need-guidance",
            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            fontSize: "26px"
                                        },
                                        children: "Need guidance? Let us help you."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/contact-us",
                                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btTranparent),
                                            children: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: `${(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().enquireBtn)} ${classname || ""} ${applyCtaButtonProps1.formClassName}`,
                                            onClick: button2Data ? ctaBtnClickHandler(applyCtaButtonProps1) : undefined,
                                            children: button2Data?.title ?? "Enquire Now"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NeedGuidance);


/***/ }),

/***/ 50281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Universities; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/universities.module.scss
var universities_module = __webpack_require__(80442);
var universities_module_default = /*#__PURE__*/__webpack_require__.n(universities_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 7 modules
var react_select_esm = __webpack_require__(15707);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./components/NeedGuidance.tsx
var NeedGuidance = __webpack_require__(84623);
// EXTERNAL MODULE: ./node_modules/next/dist/client/link.js
var client_link = __webpack_require__(48418);
var link_default = /*#__PURE__*/__webpack_require__.n(client_link);
// EXTERNAL MODULE: ./components/AdmissionsDay/StudiesFAQ.tsx
var StudiesFAQ = __webpack_require__(26102);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 9 modules
var Accordion = __webpack_require__(54076);
// EXTERNAL MODULE: ./styles/countryadmissionsday.module.scss
var countryadmissionsday_module = __webpack_require__(83157);
var countryadmissionsday_module_default = /*#__PURE__*/__webpack_require__.n(countryadmissionsday_module);
;// CONCATENATED MODULE: ./components/CountryFAQ.tsx










const CountryFAQ = ({ faqdata  })=>{
    const sliderRef = (0,react.useRef)(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 3,
        rows: 3,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    dotsClass: (countryadmissionsday_module_default()).sliderDots,
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (countryadmissionsday_module_default()).studyquas,
            style: {
                backgroundColor: faqdata?.sectionBgColor || "#FFFFFF"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (countryadmissionsday_module_default()).popularCourseslider,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                ...settings,
                                className: (countryadmissionsday_module_default()).slider,
                                ref: sliderRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: faqdata?.length > 0 && faqdata.map((faqsdata)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xl: 6,
                                                lg: 6,
                                                md: 6,
                                                sm: 12,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                                    defaultActiveKey: "0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                                        className: (countryadmissionsday_module_default()).stuAccordion,
                                                        eventKey: "1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                                                className: (countryadmissionsday_module_default()).accoHead,
                                                                children: faqsdata?.question
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Body */.Z.Body, {
                                                                className: (countryadmissionsday_module_default()).accorBody,
                                                                children: faqsdata?.answer
                                                            })
                                                        ]
                                                    })
                                                })
                                            });
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_CountryFAQ = (CountryFAQ);

// EXTERNAL MODULE: ./utils/loadJotFormScript.ts
var loadJotFormScript = __webpack_require__(97974);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var b2c_constants = __webpack_require__(90017);
;// CONCATENATED MODULE: ./components/Universities.tsx























let mounted = false;
const Universities = (props)=>{
    const router = (0,next_router.useRouter)();
    const universityData = props?.pageData;
    const jotformScriptLoaded = (0,react.useRef)(false);
    const { countrySlug , pageNumber , countryFaqsData  } = props;
    const countryFromSlug = props.countrySlug && (0,helpers/* getCountryFromSlug */.C0)(props.countrySlug, constants/* unicountries */.SS);
    const initialValues = {
        country: countryFromSlug?.replace(/ /g, ""),
        searchValue: "",
        pageNo: pageNumber ? parseInt(pageNumber?.substring(5)) : 1
    };
    const { 0: filters , 1: setFilters  } = (0,react.useState)(initialValues);
    const { 0: universities , 1: setUniversities  } = (0,react.useState)([]);
    const { 0: searchKeyword , 1: setSearchKeyword  } = (0,react.useState)("");
    const { 0: searchQuery , 1: setSearchQuery  } = (0,react.useState)({});
    const { 0: totalPages , 1: setTotalPages  } = (0,react.useState)(0);
    const { 0: totalCount , 1: setTotalCount  } = (0,react.useState)(0);
    const { country , searchValue , pageNo  } = filters;
    const { 0: paginateKey , 1: setPaginateKey  } = (0,react.useState)(0);
    const debounceSearchQuery = (0,react.useCallback)((searchKeyValue)=>{
        const search = debounce_default()(()=>setFilters((prevFilters)=>({
                    ...prevFilters,
                    searchValue: searchKeyValue
                })), 500);
        setSearchQuery((prevSearch)=>{
            if (prevSearch && prevSearch.cancel) {
                prevSearch.cancel();
            }
            return search;
        });
        search();
    }, []);
    const formInstance = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        (0,loadJotFormScript/* loadJotFormScript */.O)(()=>{
            jotformScriptLoaded.current = true;
        });
    }, []);
    const handleSearchChange = (e)=>{
        mounted = false;
        const searchValues = e.target.value;
        setSearchKeyword(searchValues);
        debounceSearchQuery(searchValues);
    };
    (0,react.useEffect)(()=>{
        if (mounted) return;
        const url = searchValue ? `&name_contains=${searchValue}` : "";
        const countryParam = countryFromSlug ? `&country=${countryFromSlug?.replace(/ /g, "")}` : "";
        const fetchData = async ()=>{
            const [universities, count] = await Promise.all([
                (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/universities?_sort=priority:ASC,created_at:asc${countryParam}&_start=${(pageNo - 1) * 28}&_limit=28${url}`, "GET", {}, "", false),
                (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/universities/count?${countryParam}${url}`, "GET", {}, "", false), 
            ]);
            setUniversities(universities);
            setTotalPages(Math.ceil(count / 28));
            setTotalCount(count);
        };
        fetchData().then(()=>{
            mounted = true;
        });
    }, [
        searchValue,
        pageNo,
        countryFromSlug
    ]);
    const selectOptions = props?.universityCountries?.length > 0 ? [
        {
            label: "All",
            value: "all"
        },
        ...props.universityCountries.map((coun)=>{
            return {
                label: coun.label,
                value: coun.label
            };
        }), 
    ] : [
        {
            label: "All",
            value: "all"
        }
    ];
    const pageRangeDisplayed = 2; // How many pages to show around the current page
    const marginPagesDisplayed = 1; // Pages at the beginning and end to always show
    const handlePageClick = (0,react.useCallback)((page)=>{
        mounted = false;
        setFilters((prevFilters)=>({
                ...prevFilters,
                pageNo: page
            }));
        const basePath = countryFromSlug ? `/universities/${countryFromSlug.toLowerCase().replace(/ /g, "-")}` : "/universities";
        const newPath = page === 1 ? basePath : `${basePath}/page-${page}`;
        router.push(newPath);
    }, [
        countryFromSlug,
        router
    ]);
    // Function to generate href based on page number and country
    const getHrefForPage = (0,react.useCallback)((page)=>{
        const basePath = countryFromSlug ? `/universities/${countryFromSlug.toLowerCase().replace(/ /g, "-")}` : `/universities`;
        return page === 1 ? basePath : `${basePath}/page-${page}`;
    }, [
        countryFromSlug
    ]);
    // Function to determine which pages to show (including ellipses)
    const getPagesToDisplay = (0,react.useCallback)(()=>{
        let pages = [];
        // Always show the first page
        if (pageNo > pageRangeDisplayed + marginPagesDisplayed + 1) {
            pages.push(1);
            pages.push("...");
        }
        // Pages around the current page
        for(let i = Math.max(1, pageNo - pageRangeDisplayed); i <= Math.min(totalPages, pageNo + pageRangeDisplayed); i++){
            pages.push(i);
        }
        // Always show the last page
        if (pageNo < totalPages - pageRangeDisplayed - marginPagesDisplayed) {
            pages.push("...");
            pages.push(totalPages);
        }
        return pages;
    }, [
        pageNo,
        totalPages,
        pageRangeDisplayed,
        marginPagesDisplayed
    ]);
    const pagesToDisplay = getPagesToDisplay();
    //String Manipulation Function
    const addSpaceToCountryName = (0,react.useCallback)((country)=>{
        return country.replace(/([a-z])([A-Z])/g, "$1 $2");
    }, []);
    const isWorking = true;
    const formattedCountry = countryFromSlug ? `${isWorking ? "in" : ""} ${addSpaceToCountryName(countryFromSlug)}` : "To Study Abroad";
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: universityData?.bannerBtn?.btnLink,
        formId: universityData?.bannerBtn?.formId,
        toOnboardingEnabled: props?.pageData?.bannerBtn?.toOnboardingEnabled
    });
    const enquireNowClickHandler = (e)=>{
        if (applyCtaButtonProps.mode === "onboarding") {
            (0,sourceTracking/* persistSourceContext */.jW)({
                sourceUrl: window.location.href,
                primarySource: b2c_constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                fifthStepVisible: universityData?.bannerBtn?.onBoardingFlow?.nearestOffice ?? true,
                coachingVisible: universityData?.bannerBtn?.onBoardingFlow?.lookingForCoaching ?? true
            });
        }
        applyCtaButtonProps.onClick?.(e);
    };
    const applyClickHandler = (applyNowButtonProps, receivedData)=>(e)=>{
            if (applyNowButtonProps?.mode === "onboarding") {
                (0,sourceTracking/* persistSourceContext */.jW)({
                    sourceUrl: window.location.href,
                    primarySource: b2c_constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                    fifthStepVisible: receivedData?.onBoardingFlow?.nearestOffice ?? true,
                    coachingVisible: receivedData?.onBoardingFlow?.lookingForCoaching ?? true
                });
            }
            applyNowButtonProps?.onClick?.(e);
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "universiti",
                className: (universities_module_default()).edtech,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (universities_module_default()).breadcrum,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                lg: 8,
                                md: 10,
                                xs: 12,
                                className: (universities_module_default()).centered,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                style: {
                                                    opacity: 0.5
                                                },
                                                href: "/",
                                                children: "Home"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                href: "",
                                                children: " Universities "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (universities_module_default()).abttopContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (universities_module_default()).abttopContentdesk,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                        children: [
                                                            " List of Top Universities ",
                                                            formattedCountry
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: props?.pageData?.description
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                id: "enquirebtn",
                                                variant: "primary",
                                                size: "lg",
                                                onClick: enquireNowClickHandler,
                                                className: `${(universities_module_default()).enquirebtn} ${applyCtaButtonProps.formClassName}`,
                                                children: props?.pageData?.bannerBtn?.label || "Enquire Now"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "search-study-des",
                className: (universities_module_default()).searchStudyDesti,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (universities_module_default()).searchPan,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (universities_module_default()).searchBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-center",
                                children: "Select Country"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (universities_module_default()).subscribeForm,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                        options: selectOptions,
                                        placeholder: "All",
                                        isClearable: false,
                                        className: (universities_module_default()).selectClass,
                                        "aria-label": "Select country",
                                        classNamePrefix: "mySelect",
                                        components: {
                                            IndicatorSeparator: ()=>null
                                        },
                                        value: countryFromSlug && {
                                            label: countryFromSlug,
                                            value: countryFromSlug
                                        },
                                        onChange: (selected)=>{
                                            mounted = false;
                                            setPaginateKey(paginateKey + 1);
                                            setFilters({
                                                ...filters,
                                                country: selected.value,
                                                pageNo: 1
                                            });
                                            const newPath = selected.label === "All" ? `/universities` : `/universities/${(0,helpers/* getSlugFromCountryUni */.Ye)(selected.value, constants/* unicountries */.SS)}`;
                                            router.push(newPath);
                                        }
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "university-resu",
                className: (universities_module_default()).universityResults,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: (universities_module_default()).showResult,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 9,
                                    md: 8,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Showing Results in",
                                            " ",
                                            countryFromSlug ? countryFromSlug : "All Countries"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 3,
                                    md: 4,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                        className: "navbar-form",
                                        role: "search",
                                        onSubmit: (e)=>e.preventDefault(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "input-group add-on",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (universities_module_default()).inputBox,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-control",
                                                        placeholder: "Search Universities",
                                                        type: "text",
                                                        value: searchKeyword,
                                                        onChange: handleSearchChange,
                                                        "aria-label": "Search universities",
                                                        name: "search-universities"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (universities_module_default()).inputBtn,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/searchco.svg",
                                                            alt: "searchco",
                                                            width: 14,
                                                            height: 14
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                lg: 12,
                                md: 12,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    children: [
                                        universities?.length > 0 && universities.map((data, index)=>{
                                            const slug = data.slug;
                                            const url = slug && data.country ? `/universities/${(0,helpers/* getSlugFromCountryUniDetail */.gX)(data.country, constants/* unicountries */.SS)}/${slug}` : "";
                                            const applyNowButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
                                                btnLink: data?.card?.button2?.btnLink,
                                                formId: data?.card?.button2?.formId,
                                                toOnboardingEnabled: data?.card?.button2?.toOnboardingEnabled
                                            });
                                            return slug ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xxl: 3,
                                                xl: 3,
                                                lg: 4,
                                                md: 4,
                                                sm: 6,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: `${(universities_module_default()).univerResult} ${url ? `${(universities_module_default()).activeUrl}` : `${(universities_module_default()).deactiveUrl}`}`,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: `${(universities_module_default()).uniLogo} p-0`,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: data?.universityLogo?.imageUrl || "/images/university-detail-gallery/university-dummy-logo.jpg",
                                                                alt: data?.image?.alt || data?.name,
                                                                width: 261,
                                                                height: 118
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (universities_module_default()).alignmentText,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                    children: data?.name
                                                                }),
                                                                data?.card?.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: (universities_module_default())["card-desc"],
                                                                    children: data?.card?.description
                                                                }),
                                                                data?.location && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    children: data?.location
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: data?.universityUrl
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (universities_module_default()).footerButton,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    onClick: ()=>window.open(url, "_blank"),
                                                                    className: (universities_module_default()).knowMore,
                                                                    children: data?.card?.button1?.title ?? "Know More"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    className: `${(universities_module_default()).applyNow} ${applyNowButtonProps.formClassName}`,
                                                                    onClick: applyClickHandler(applyNowButtonProps, data?.card?.button2),
                                                                    children: data?.card?.button2?.label ?? "Apply Now"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index)
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xxl: 3,
                                                xl: 3,
                                                lg: 4,
                                                md: 4,
                                                sm: 6,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: `${(universities_module_default()).univerResult} ${(universities_module_default()).deactiveUrl}`,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: `${(universities_module_default()).uniLogo} p-0`,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: data?.universityLogo?.imageUrl || "/images/university-detail-gallery/university-dummy-logo.jpg",
                                                                alt: data?.image?.alt,
                                                                width: 261,
                                                                height: 118
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (universities_module_default()).alignmentText,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                    children: data?.name
                                                                }),
                                                                data?.card?.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: (universities_module_default())["card-desc"],
                                                                    children: data?.card?.description
                                                                }),
                                                                data?.location && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    children: data?.location
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: data?.universityUrl
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (universities_module_default()).footerButton,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                className: `${(universities_module_default()).applyNow} ${applyNowButtonProps.formClassName}`,
                                                                onClick: applyClickHandler(applyNowButtonProps, data?.card?.button2),
                                                                children: data?.card?.button2?.label ?? "Apply Now"
                                                            })
                                                        })
                                                    ]
                                                }, index)
                                            });
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: (universities_module_default()).pagination,
                                            children: [
                                                pageNo > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "previous",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: getHrefForPage(pageNo - 1),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: ()=>handlePageClick(pageNo - 1),
                                                            "aria-label": "Previous page",
                                                            rel: "prev",
                                                            children: "<"
                                                        })
                                                    })
                                                }),
                                                pagesToDisplay.map((page, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: pageNo === page ? (universities_module_default()).active : "",
                                                        children: page === "..." ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "ellipsis",
                                                            children: "..."
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: getHrefForPage(page),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: ()=>handlePageClick(Number(page)),
                                                                "aria-label": `Page ${page}`,
                                                                rel: pageNo === page ? "canonical" : "next",
                                                                children: page
                                                            })
                                                        })
                                                    }, index)),
                                                pageNo < totalPages && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "next",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: getHrefForPage(pageNo + 1),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: ()=>handlePageClick(pageNo + 1),
                                                            "aria-label": "Next page",
                                                            rel: "next",
                                                            children: ">"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedGuidance/* default */.Z, {
                    classname: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid || "241383394530456")}`
                })
            }),
            router.pathname === "/universities" && props?.pageData?.faqSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StudiesFAQ["default"], {
                    faqdata: props?.pageData?.faqSection
                })
            }),
            !(router.pathname === "/universities") && countryFromSlug && pageNo == 1 && props?.countryFaqsData?.length > 0 && props.countryFaqsData.some((item)=>item.countriesFaq?.university_country?.label === countryFromSlug || item.countriesFaq?.university_country?.value === countryFromSlug) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (universities_module_default()).countryFaq,
                style: {
                    backgroundColor: "#FFFFFF"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (universities_module_default()).heading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    children: [
                                        " Frequently Asked Questions about ",
                                        countryFromSlug,
                                        " Universities"
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CountryFAQ, {
                        faqdata: props?.countryFaqsData.find((item)=>item.countriesFaq?.university_country?.label === countryFromSlug || item.countriesFaq?.university_country?.value === countryFromSlug)?.countriesFaq?.faq
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Universities = (Universities);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 97974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ loadJotFormScript; }
/* harmony export */ });
const loadJotFormScript = (callback)=>{
    const feedbackScriptId = "jotform-feedback-script";
    if (!document.getElementById(feedbackScriptId)) {
        const feedbackScript = document.createElement("script");
        feedbackScript.src = "https://form.jotform.com/static/feedback2.js";
        feedbackScript.type = "text/javascript";
        feedbackScript.id = feedbackScriptId;
        feedbackScript.onload = ()=>{
            if (callback) callback();
        };
        document.body.appendChild(feedbackScript);
    } else {
        if (callback) callback();
    }
};


/***/ }),

/***/ 65822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentFooter":"NeedGuidance_studentFooter__5o74_","session":"NeedGuidance_session__8Zc7c","anchor":"NeedGuidance_anchor__9XZiq","enquireBtn":"NeedGuidance_enquireBtn__u9ZDM","btTranparent":"NeedGuidance_btTranparent__iNGT9"};

/***/ }),

/***/ 83157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"countryadmissionsday_banner__kiMij","nav":"countryadmissionsday_nav__Stoca","navLogo":"countryadmissionsday_navLogo__9pU_M","maincontent":"countryadmissionsday_maincontent__EWEY_","fairdetails":"countryadmissionsday_fairdetails__Q9kXE","heading":"countryadmissionsday_heading__oUjWt","ulli":"countryadmissionsday_ulli__Mhf1j","regBtn":"countryadmissionsday_regBtn__Vf3yK","btnReg":"countryadmissionsday_btnReg__iT8q7","bannerStudDiv":"countryadmissionsday_bannerStudDiv__EQIjZ","bg":"countryadmissionsday_bg__RN8Zt","benefitsAttend":"countryadmissionsday_benefitsAttend__bvSoj","maindiv":"countryadmissionsday_maindiv__6v1if","mainBox":"countryadmissionsday_mainBox__Wl52Z","box":"countryadmissionsday_box__8dxaS","img":"countryadmissionsday_img__dv_xO","popularcourses":"countryadmissionsday_popularcourses__jyhHM","card":"countryadmissionsday_card__u19D_","cardImgDiv":"countryadmissionsday_cardImgDiv__CvCb0","cardImg":"countryadmissionsday_cardImg__rxXNr","cardBody":"countryadmissionsday_cardBody__DqTNl","caption":"countryadmissionsday_caption__p1FL9","caption2":"countryadmissionsday_caption2__0ZZIA","sliderDots":"countryadmissionsday_sliderDots__YKBHs","studentSpecialOffer":"countryadmissionsday_studentSpecialOffer__MJVJT","stuImg":"countryadmissionsday_stuImg__AXevw","whystuImg":"countryadmissionsday_whystuImg__yYoGk","stuImgtext":"countryadmissionsday_stuImgtext__7RB1a","stuImgtextd":"countryadmissionsday_stuImgtextd__y1nZx","headingabout":"countryadmissionsday_headingabout__UoSJC","OffersContent":"countryadmissionsday_OffersContent___hKfL","ulItem":"countryadmissionsday_ulItem__yRlU7","liItem":"countryadmissionsday_liItem__PuSD8","anchor":"countryadmissionsday_anchor__4W9FQ","row":"countryadmissionsday_row__i9im3","ScholarshipStudent":"countryadmissionsday_ScholarshipStudent__IaBcj","schStImg":"countryadmissionsday_schStImg__ykGre","SchContent":"countryadmissionsday_SchContent__49H1Q","studyquas":"countryadmissionsday_studyquas__EmUX3","stuAccordion":"countryadmissionsday_stuAccordion__VbaZm","accordion-button":"countryadmissionsday_accordion-button__Rh70t","collapsed":"countryadmissionsday_collapsed__J8CFE","accoHead":"countryadmissionsday_accoHead__tddyE","arrowsClass":"countryadmissionsday_arrowsClass__5cP_b","btcircle":"countryadmissionsday_btcircle__TCk9W","studentFooter":"countryadmissionsday_studentFooter__3qaYy","session":"countryadmissionsday_session__aK7h9","popularCoursesbg":"countryadmissionsday_popularCoursesbg__DA_qC","popularCourseslider":"countryadmissionsday_popularCourseslider__H3E7V","studyServSection":"countryadmissionsday_studyServSection__VYBux","imgPosition":"countryadmissionsday_imgPosition__CGsRP","txtPosition":"countryadmissionsday_txtPosition__HgE3L","studyContent":"countryadmissionsday_studyContent__q6tUY","studyContentpink":"countryadmissionsday_studyContentpink__WPJBO","platformDivImg":"countryadmissionsday_platformDivImg__R7aEn","picRound":"countryadmissionsday_picRound__DpvDp","pica":"countryadmissionsday_pica__XFIO9","picb":"countryadmissionsday_picb__Zztdr","picc":"countryadmissionsday_picc__Phr1j","picd":"countryadmissionsday_picd__gNom0","ulliQuick":"countryadmissionsday_ulliQuick__7OfrH","ulliQuickli":"countryadmissionsday_ulliQuickli__Aiptw","quickImg":"countryadmissionsday_quickImg__Yb4B_"};

/***/ }),

/***/ 80442:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"universities_hide-scrollbar__sRFib","abttopContent":"universities_abttopContent__iOYTP","abttopContentdesk":"universities_abttopContentdesk__N5STN","abttopContentMobile":"universities_abttopContentMobile__0n00y","edtech":"universities_edtech__zcP0a","parentMain":"universities_parentMain__Ol93D","first":"universities_first__7amE5","second":"universities_second__VOKcH","childa":"universities_childa__1T1XI","breadcrum":"universities_breadcrum__9YwG0","enquirebtn":"universities_enquirebtn__6yQZX","heading":"universities_heading__Jzx2_","buttongp":"universities_buttongp__iwm3o","kcbtn":"universities_kcbtn__n_TkZ","centered":"universities_centered__Z7QS4","breadcrumb-item":"universities_breadcrumb-item__fZTWy","active":"universities_active__WhAcz","mainTitle":"universities_mainTitle__H_4TZ","universityResults":"universities_universityResults__CrFRh","showResult":"universities_showResult__eeR6E","desk":"universities_desk__6hGVa","mobile":"universities_mobile__Tn3t4","alignmentText":"universities_alignmentText__f6Ocm","country_flags":"universities_country_flags__DHZiW","flagImgContent":"universities_flagImgContent__0rAAY","activeUrl":"universities_activeUrl__6MQg1","deactiveUrl":"universities_deactiveUrl__d7XX5","univerResult":"universities_univerResult__ILYZu","card-desc":"universities_card-desc__ote7D","footerButton":"universities_footerButton__IKWje","applyNow":"universities_applyNow__G9cy4","knowMore":"universities_knowMore__o_H3k","uniLogo":"universities_uniLogo__fOUiW","nobr":"universities_nobr__CQsWb","viewMore":"universities_viewMore__R5SfL","inputBox":"universities_inputBox__00ctQ","inputBtn":"universities_inputBtn__DTHJP","searchStudyDesti":"universities_searchStudyDesti___L_ps","searchPan":"universities_searchPan__k72lX","searchBox":"universities_searchBox__kinwr","searchtxt":"universities_searchtxt__7LkL_","subscribeForm":"universities_subscribeForm__zWJr3","selectClass":"universities_selectClass__RlH_5","pagination":"universities_pagination__68CyM","activeli":"universities_activeli__bjeai","countryFaq":"universities_countryFaq__5_l9e"};

/***/ })

}]);